export const generateCode = () => {
  const date = Date.now() + '',
    res = date.match(/(\d{6})(\d{7})/);
    return res? res[2]: '';
}